import {
    StyledRateConversionHelperText,
    StyledRateFieldTextWithToggleGroupText,
    StyledTextWithToggleGroupContainer,
    StyledTextWithToggleGroupToggleCompact
} from './StyledTextWithToggleGroup.styles';
import RateTypeToggleGroup from './RateTypeToggleGroup.interstate';
import SellRateInput from './SellRateInput.interstate';
import FieldOverrideIndicator from './FieldOverrideIndicator.interstate';
import type { DealTabs } from '@makemydeal/dr-shared-types';
import { useSellRateField } from './hooks/useSellRateField';

const SellRateField = ({ tabName, onLenderSlideOutOpen }: { tabName?: DealTabs; onLenderSlideOutOpen?: () => void }) => {
    const {
        label,
        isLeaseOffer,
        isSummaryTab,
        isLenderTab,
        isAprRateType,
        isLocked,
        isPaymentGridEnabled,
        isUserProgramQuotes,
        convertedRateText,
        onLabelActivate,
        onRateTypeToggle,
        overrideIndicatorProps,
        inputProps
    } = useSellRateField({ tabName, onLenderSlideOutOpen });
    const { name: fieldName, ...sellRateInputProps } = inputProps;

    return (
        <>
            {isLeaseOffer ? (
                <StyledTextWithToggleGroupContainer>
                    <StyledRateFieldTextWithToggleGroupText gap="0">
                        <FieldOverrideIndicator {...overrideIndicatorProps} reserveSpace={!isLenderTab} overlayIcon={isLenderTab}>
                            <SellRateInput
                                showLabelLink={isSummaryTab}
                                size="sm"
                                label={label}
                                name={fieldName}
                                {...sellRateInputProps}
                                dataTestId={fieldName}
                                handleClick={onLabelActivate}
                                readOnly={isPaymentGridEnabled}
                            />
                            {!isUserProgramQuotes && !isPaymentGridEnabled && !isSummaryTab && (
                                <StyledRateConversionHelperText data-testid="sell-rate-conversion-helper">
                                    {convertedRateText}
                                </StyledRateConversionHelperText>
                            )}
                        </FieldOverrideIndicator>
                    </StyledRateFieldTextWithToggleGroupText>
                    {!isPaymentGridEnabled && isUserProgramQuotes && (
                        <StyledTextWithToggleGroupToggleCompact showLabelLink={isSummaryTab}>
                            <RateTypeToggleGroup
                                inputField="sell-rate"
                                isAPRRateType={isAprRateType}
                                handleOnClick={onRateTypeToggle}
                                disabled={isLocked}
                            />
                        </StyledTextWithToggleGroupToggleCompact>
                    )}
                </StyledTextWithToggleGroupContainer>
            ) : (
                <FieldOverrideIndicator {...overrideIndicatorProps} reserveSpace={!isLenderTab} overlayIcon={isLenderTab}>
                    <SellRateInput
                        showLabelLink={isSummaryTab}
                        size={'sm'}
                        label={label}
                        name={fieldName}
                        {...sellRateInputProps}
                        dataTestId={fieldName}
                        handleClick={onLabelActivate}
                        readOnly={isPaymentGridEnabled}
                    />
                </FieldOverrideIndicator>
            )}
        </>
    );
};

export default SellRateField;
